/* Club points are hidden for now (Joe, 19 Oct 2026: "lets hide the points for now"): no loyalty app awards them yet.
   Everything that promises points, and every link to the Club, comes out of the page. The Club page itself still exists
   (hidden in Shopify), so switching this back on is deleting this file's <script> tag. */
(function () {
  var doc = document.documentElement; doc.classList.add('club-off', 'ac-noclub');
  var CLUB = /\/pages\/(poorly-pet-)?club\b/;
  var queued = false;
  function gone(el) { if (el && el.style.display !== 'none') el.style.display = 'none'; }
  function apply() {
    queued = false;
    ['#club-sec', '#club-btn', '#n2-club', '.n2-rpts', '#topic-club', '.hero-grid .tile.deep', '#clubdrawer', '[data-open="clubdrawer"]'].forEach(function (s) {
      Array.prototype.forEach.call(document.querySelectorAll(s), gone);
    });
    if (!/\/pages\/(poorly-pet-)?club/.test(location.pathname)) {
      Array.prototype.forEach.call(document.querySelectorAll('a[href]'), function (a) {
        if (!CLUB.test(a.getAttribute('href') || '') && a.getAttribute('href') !== '#topic-club') return;
        if (a.closest('#club-sec, .pst-row')) return;
        var li = a.closest('li'); gone(li && li.querySelectorAll('a').length === 1 ? li : a);
      });
    }
    /* the basket page's small print: "Club members earn N points on this order." goes, the discount line stays */
    Array.prototype.forEach.call(document.querySelectorAll('.ct-fine'), function (el) {
      if (/points/i.test(el.textContent)) el.textContent = 'Discount codes go in at checkout.';
    });
    /* answers, facts and questions that are about points */
    Array.prototype.forEach.call(document.querySelectorAll('.fq-it, .ss-facts li, .qa > button.q, .n2-faq .q, .ac-kv > div, #account-body .row'), function (el) {
      if (/\bClub points\b|\bpoints\b/i.test(el.textContent)) { gone(el); if (el.matches('button.q') && el.nextElementSibling) gone(el.nextElementSibling); }
    });
  }
  function queue() { if (!queued) { queued = true; requestAnimationFrame(apply); } }
  apply();
  if (window.MutationObserver) new MutationObserver(queue).observe(doc, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', apply);
})();
